import { queryKeys } from "@/lib/useQuery/queryKeys";
import { useQuery } from "@tanstack/react-query";
import { GetAllCrmProjectsListProps } from ".";

export function useAllCrmProjectsList({whereCrmSystems, orgId}: GetAllCrmProjectsListProps) {
    return useQuery({
        ...queryKeys.crm_project.list._ctx.byOrgId(orgId)._ctx.byCrmSystemsArr(whereCrmSystems),
    });
}